import { Grid, Toolbar, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTextField from "../../../../components/CustomTextField";
import { getClinicStocksWoLoader } from "../../../../redux/reducers/clinicSlice";
import { getMedicalHistoryByPetId } from "../../../../redux/reducers/medicalHistorySlice";
import { AppColors } from "../../../../util/AppColors";
import { getKey } from "../../../../util/function";
import BodyMapView from "../../../CommonScreens/WorkBook/BodyMapView";
import DiagnosticsView from "../../../CommonScreens/WorkBook/DiagnosticsView";
import FileView from "../../../CommonScreens/WorkBook/FileView";
import FormsView from "../../../CommonScreens/WorkBook/FormsView";
import PrescriptionView from "../../../CommonScreens/WorkBook/PrescriptionView";
import PreventiveView from "../../../CommonScreens/WorkBook/PreventiveView";
import SoapNoteView from "../../../CommonScreens/WorkBook/SoapNoteView";
import TreatmentPlanView from "../../../CommonScreens/WorkBook/TreatmentPlanView";
import VitalsView from "../../../CommonScreens/WorkBook/VitalsView";

const arrow = { width: 30, height: 30, color: AppColors.appPrimary };

const MedicalHistoryNew = ({ petId }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Problem");
  const [searchValue, setSearchValue] = useState("");
  const [samData, setSamData] = useState([]);
  const [heights, setHeights] = useState([]);
  const medicalHistory = useSelector(
    (state) => state?.medicalHistory?.petMedicalHistory
  );
  const petDet = useSelector(
    (state) => state?.pet?.complaintSummary?.data?.pet
  );
  const { clinicStocks } = useSelector((state) => state?.clinic);

  useEffect(() => {
    dispatch(getMedicalHistoryByPetId({ petId }));
    dispatch(getClinicStocksWoLoader());
  }, []);

  // useEffect(() => {
  //   // Wait for the component to render and then get heights of all w100Per divs
  //   const handleResize = () => {
  //     const elements = document.querySelectorAll(".getHeight");
  //     const newHeights = Array.from(elements).map((el) => el.clientHeight);
  //     setHeights(newHeights);

  //     const lineHeight =
  //       newHeights.length > 1
  //         ? newHeights.reduce((a, b) => a + b, 0) / newHeights.length
  //         : 0;
  //     document.querySelectorAll(".connecting-line").forEach((line) => {
  //       line.style.height = `${lineHeight}px`;
  //     });
  //   };

  //   handleResize(); // Get the initial heights
  //   window.addEventListener("resize", handleResize); // Update heights on window resize
  //   return () => window.removeEventListener("resize", handleResize); // Cleanup event listener
  // }, [samData]);

  const handleOpen = (name, i, value) => {
    const reqData = samData?.map((dta, ind) => {
      if (i === ind) {
        return { ...dta, [name]: { ...dta[name], open: value } };
      }
      return dta;
    });
    setSamData(reqData);
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId
    );
    return reqStock?.stockBatch ?? [];
  };

  return (
    <>
      <div className="scroll-80vh w100Per">
        <Grid container className="back-white">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="ph20">
            <Toolbar variant="regular">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row">
                  <div className="top-row-cen-con w100Per">
                    <div className="w35Per">
                      <CustomTextField
                        placeholder="Search"
                        fullWidth
                        backgroundColor={AppColors.lightPink}
                        value={searchValue}
                        handleChange={(e) => setSearchValue(e?.target?.value)}
                      />
                    </div>

                    {/* <div className="top-row-right-con topBar-select">
                      <div className="flex-row-ali-cen">
                        <div
                          className="ph10pv3"
                          onClick={() => setActiveTab("Problem")}
                        >
                          <div
                            className={`flex-center cursor ${
                              activeTab === "Problem"
                                ? "pet-det-sel-tab"
                                : "pet-det-un-sel-tab"
                            }`}
                          >
                            Problem View
                          </div>
                        </div>
                        <div
                          className="ph10pv3"
                          onClick={() => setActiveTab("Timeline")}
                        >
                          <div
                            className={`flex-center cursor ${
                              activeTab === "Timeline"
                                ? "pet-det-sel-tab"
                                : "pet-det-un-sel-tab"
                            }`}
                          >
                            Timeline View
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </Grid>
            </Toolbar>

            {activeTab === "Problem"
              ? medicalHistory?.data
                  ?.filter((li) =>
                    ["finalize", "completed"].includes(
                      li?.appointmentStatus?.toLowerCase()
                    )
                  )
                  ?.map((li, i) => {
                    return (
                      <div
                        className="w100Per getHeight"
                        key={getKey()}
                        // style={i !== 0 ? { marginTop: -40 } : { marginTop: 10 }}
                      >
                        <div className="flex-row mt20">
                          <div className="flex-column">
                            <div className="flex-center h50">
                              <div className="gry-dot" />
                            </div>
                            <div
                              style={{
                                width: 1,
                                height: heights?.[i] - 0,
                                background: "#00000033",
                                marginLeft: 5,
                                marginTop: -20,
                              }}
                            />
                          </div>

                          <div
                            className={`w10Per  ${li?.isMaster ? "" : "ml40"}`}
                          >
                            <div className="flex-column flex-center">
                              <Typography className="blue-color txt-semi-bold fs30 mb10Min">
                                {moment(li?.date).format("DD")}
                              </Typography>
                              <Typography className="blue-color txt-semi-bold fs12">
                                {moment(li?.date).format("MMM YYYY")}
                              </Typography>

                              <div
                                className={`mt5 ${
                                  li?.isMaster
                                    ? "org-time-highlight"
                                    : "rse-time-highlight"
                                }`}
                              />
                            </div>
                          </div>
                          <div className="w80Per">
                            <div className="his-bodr">
                              <div className="flex-row-ali-cen p10">
                                <div>
                                  <div className="flex-row-ali-cen">
                                    <Typography className="font-bold fs14 blue-color">
                                      Case ID - {li?.caseId}
                                    </Typography>
                                    <Typography className="light-blue fs14 txt-semi-bold ml10">
                                      {li?.serviceType}
                                      {li?.serviceType === "Consultation"
                                        ? ` | ${
                                            Array.isArray(li?.reason)
                                              ? li?.reason?.join(", ")
                                              : ""
                                          }`
                                        : ""}
                                    </Typography>

                                    {/* <Typography
                                    className={`fs12 font-medium ml10 ${
                                      li?.isMaster
                                        ? "org-tag light-ornge"
                                        : "rose-tag white1"
                                    }`}
                                  >
                                    {li?.isMaster ? "Master" : "Child"}
                                  </Typography> */}
                                    {li?.tags?.map((tg, i) => (
                                      <Typography
                                        className="fs12 font-medium black19 ml10 gry-tag"
                                        key={tg + i}
                                      >
                                        {tg}
                                      </Typography>
                                    ))}
                                  </div>
                                  <div className="flex-row-ali-cen mt10">
                                    <img
                                      src={require("../../../../assets/images/png/calen.png")}
                                      className="img-wh15"
                                    />
                                    <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                      {moment(
                                        new Date(li?.appointmentTime)
                                      ).format("DD MMM YYYY")}
                                    </Typography>
                                    <img
                                      src={require("../../../../assets/images/png/clock.png")}
                                      className="img-wh15 ml10"
                                    />
                                    <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                      {moment(
                                        new Date(li?.appointmentTime)
                                      ).format("HH:mm")}
                                    </Typography>
                                    <img
                                      src={require("../../../../assets/images/png/steath.png")}
                                      className="img-wh15 ml10"
                                    />
                                    <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                      Dr. {li?.doctorName}
                                    </Typography>
                                  </div>
                                </div>
                                <div className="flex1-end">
                                  <div className="flex-column">
                                    {/* <div className="flex-end">
                                    <Typography
                                      className={`fs12 font-bold white-color ${
                                        li?.status === "Under Treatment" ||
                                        li?.status === "Monitoring"
                                          ? "yellow-tag"
                                          : li?.status === "Inactive"
                                          ? "org-tag"
                                          : li?.status === "Resolved"
                                          ? "grn-tag"
                                          : "red-tag"
                                      }`}
                                    >
                                      {li?.status}
                                    </Typography>
                                  </div> */}
                                    {/* <div className="flex-row-ali-cen mt10">
                                    <Typography className="gray21 fs12 font-medium">
                                      Connections:
                                    </Typography>
                                    <Typography
                                      className={`fs12 font-medium ml5 ${
                                        li?.isMaster ? "rose" : "orange5"
                                      }`}
                                    >
                                      {li?.connections?.length}{" "}
                                      {li?.isMaster ? "Child" : "Master"}
                                    </Typography>
                                  </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="ph5">
                                <div className="gry-hor-split mt5" />
                              </div>
                              <div className="p10">
                                <div key={getKey()}>
                                  {li?.procedures?.filter(
                                    (prd) =>
                                      prd?.appointmentId === li?.appointmentId
                                  )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "procedures",
                                            i,
                                            !li?.procedures?.open
                                          );
                                        }}
                                      >
                                        <Typography className="font-bold fs14 blue-color">
                                          Procedures
                                        </Typography>
                                      </div>
                                      {li?.procedures
                                        ?.filter(
                                          (prd) =>
                                            prd?.appointmentId ===
                                            li?.appointmentId
                                        )
                                        ?.map((pl) => (
                                          <Typography
                                            className="txt-semi-bold black fs12"
                                            key={pl?.procedureId}
                                          >
                                            {pl?.procedureName}
                                          </Typography>
                                        ))}
                                      {li?.procedures
                                        ?.filter(
                                          (prd) =>
                                            prd?.appointmentId ===
                                            li?.appointmentId
                                        )
                                        ?.map((prli) =>
                                          prli?.procedureDetails
                                            ?.filter(
                                              (itm) =>
                                                itm?.type?.toLowerCase() ===
                                                  "administered" &&
                                                itm?.status === "true"
                                            )
                                            ?.map((pldet) => (
                                              <div
                                                className="gray-back-con1 mv5"
                                                key={pldet?.detailId}
                                              >
                                                <div className="flex-row-ali-cen flex-row-wrap">
                                                  <Typography className="txt-semi-bold black fs12">
                                                    Name: {pldet?.procedureName}
                                                  </Typography>
                                                  <div className="gray-dot2 mh5" />
                                                  <Typography className="font-medium black4 fs12">
                                                    Quantity:
                                                  </Typography>
                                                  <Typography className="txt-regular black4 fs12 ml5">
                                                    {li?.quantity ?? "1"}
                                                  </Typography>
                                                  <div className="gray-dot2 mh5" />
                                                  <Typography className="font-medium black4 fs12">
                                                    Batch Number:
                                                  </Typography>
                                                  <Typography className="txt-regular black4 fs12 ml5">
                                                    {getBatchList(
                                                      pldet?.stockId
                                                    )?.find(
                                                      (li) =>
                                                        li?.batchId ===
                                                        pldet?.batchId
                                                    )?.batchNo ?? ""}
                                                  </Typography>
                                                  <div className="gray-dot2 mh5" />
                                                  <Typography className="font-medium black4 fs12">
                                                    Dosage:
                                                  </Typography>
                                                  <Typography className="txt-regular black4 fs12 ml5">
                                                    {pldet?.dosage ?? ""}{" "}
                                                    {`/${
                                                      getBatchList(
                                                        pldet?.stockId
                                                      )?.[0]?.packageUom
                                                    }`}
                                                  </Typography>
                                                  <div className="gray-dot2 mh5" />
                                                  <Typography className="font-medium black4 fs12">
                                                    Route:
                                                  </Typography>
                                                  <Typography className="txt-regular black4 fs12 ml5">
                                                    {pldet?.route ?? ""}
                                                  </Typography>
                                                </div>
                                              </div>
                                            ))
                                        )}
                                    </>
                                  ) : null}
                                  {/* <Typography className="font-bold fs14 blue-color">
                                  Summary
                                </Typography>
                                <Typography className="txt-regular fs12 gray11 ph20">
                                  Test
                                </Typography> */}
                                  {li?.prevetive?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "preventives",
                                            i,
                                            !li?.preventives?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.preventives?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Preventive
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="mr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>

                                      <PreventiveView
                                        preventives={li?.prevetive}
                                      />
                                    </>
                                  ) : null}
                                  {li?.diagnostics?.filter(
                                    (li) =>
                                      li?.status?.toLowerCase() === "completed"
                                  )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "diagnostics",
                                            i,
                                            !li?.diagnostics?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.diagnostics?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Diagnostics
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>

                                      <DiagnosticsView
                                        diagnostics={li?.diagnostics?.filter(
                                          (li) =>
                                            li?.status?.toLowerCase() ===
                                            "completed"
                                        )}
                                      />
                                    </>
                                  ) : null}
                                  {li?.prescription?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "prescriptions",
                                            i,
                                            !li?.prescriptions?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.prescriptions?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Prescription
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="mr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <PrescriptionView
                                        prescriptions={li?.prescription}
                                      />
                                    </>
                                  ) : null}
                                  {li?.clinicalNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId
                                  ) ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Soap Notes
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <SoapNoteView
                                        apntId={li?.appointmentId}
                                        soapNote={li?.clinicalNotes?.find(
                                          (cn) =>
                                            cn?.appointmentId ===
                                            li?.appointmentId
                                        )}
                                      />
                                    </>
                                  ) : null}
                                  {li?.inpatientNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.type === "surgery" &&
                                      cn?.consolidated
                                  ) ??
                                  li?.inpatientNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.type === "surgery"
                                  ) ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Surgery Documentation
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <SoapNoteView
                                        apntId={li?.appointmentId}
                                        soapNote={
                                          li?.inpatientNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.type === "surgery" &&
                                              cn?.consolidated
                                          ) ??
                                          li?.inpatientNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.type === "surgery"
                                          )
                                        }
                                        isSurgery
                                      />
                                    </>
                                  ) : null}
                                  {li?.treatmentPlan?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Protocol Forms
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <TreatmentPlanView
                                        plans={li?.treatmentPlan}
                                      />
                                    </>
                                  ) : null}
                                  {li?.forms?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Consent Forms
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <FormsView forms={li?.forms} />
                                    </>
                                  ) : null}
                                  {li?.vitals?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Vitals
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <VitalsView vitals={li?.vitals} />
                                    </>
                                  ) : null}
                                  {li?.bodyMaps?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Body Map
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <BodyMapView bodyMaps={li?.bodyMaps} />
                                    </>
                                  ) : null}
                                  {li?.files?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Files
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <FileView files={li?.files} />
                                    </>
                                  ) : null}
                                  {/* <div
                                  className="mt10 flex-row-ali-cen"
                                  onClick={() => {
                                    handleOpen("others", i, !li?.others?.open);
                                  }}
                                >
                                  <Typography className="font-bold fs14 blue-color">
                                    Others
                                  </Typography>
                                </div>

                                {li?.others?.open ? (
                                  li?.others?.list?.length > 0 ? (
                                    li?.others?.list?.map((pre, i) => (
                                      <div
                                        className="mt5 mh10"
                                        key={i + "other"}
                                      >
                                        <div className="gray-back-con1">
                                          <div className="flex-row-wrap1">
                                            <Typography className="fs12 txt-semi-bold black">
                                              Product Name: Anobivac
                                            </Typography>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Vaccine:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                Hepatitis
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Manufacturer:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                Healthcare Plus
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Batch No:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                B2
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Dose:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                1 mg
                                              </Typography>
                                            </div>

                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Administered date & by:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                12 - 06 - 2024 | Dr Rahul
                                              </Typography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="no-rec">
                                      No records available
                                    </div>
                                  )
                                ) : null}

                                <div className="blue-box-brdr mt10">
                                  <Typography className="font-bold fs14 blue-color">
                                    Additional Notes
                                  </Typography>
                                  <Typography className="txt-regular fs12 gray11 ph20">
                                    {li?.additionalNotes}
                                  </Typography>
                                </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
              : null}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default MedicalHistoryNew;
